export default __webpack_public_path__ + "fa59548c6ecde77ce07d7333f2029d36.svg";